import axios from "axios";
import config from "../config";
import { handlingSession, sessionID } from "./../../utils/handlingSession";
import { userLogs } from "./../logs/userLogs";

export const verifyAdminOTP = async (payload) => {
	let url = config.hummBackendAppURL + "admin/verify-admin-otp";
	return axios
		.post(url, payload, { headers: sessionID() })
		.then((response) => {
			return response.data;
		})
		.catch(async (error) => {
			await userLogs(url, {}, error);
			if (error.response) {
				handlingSession(error.response.status);
			}
			return error.response?.data;
		});
};

export const resendAdminOTP = async (payload) => {
	let url = config.hummBackendAppURL + "admin/resend-admin-otp";

	return axios
		.post(url, payload, { headers: sessionID() })
		.then((response) => {
			return response.data;
		})
		.catch(async (error) => {
			await userLogs(url, {}, error);
			if (error.response) {
				handlingSession(error.response.status);
			}
			return error.response?.data;
		});
};

export const getAdminDetails = async (formData) => {
	let url = config.hummBackendAppURL + "admin/getAdmin";
	return axios
		.post(url, formData, { headers: sessionID() })
		.then((res) => {
			return res;
		})
		.catch(async (err) => {
			await userLogs(url, formData, err);
			if (err.response) {
				handlingSession(err.response.status);
			}
			return err.response;
		});
};

export const getActiveLoginUsersList = async (payload) => {
	let url = config.hummBackendAppURL + "admin/get-active-login-users";
	return axios
		.post(url, payload, { headers: sessionID() })
		.then((response) => {
			return response.data;
		})
		.catch(async (error) => {
			await userLogs(url, payload, error);
			if (error.response) {
				handlingSession(error.response.status);
			}
			return error.response;
		});
};

export const getAdminList = async (payload) => {
	let url = config.hummBackendAppURL + "admin/get-admin-list";
	return axios
		.post(url, payload, { headers: sessionID() })
		.then((response) => {
			return response.data;
		})
		.catch(async (error) => {
			await userLogs(url, payload, error);
			if (error.response) {
				handlingSession(error.response.status);
			}
			return error.response;
		});
};

export const getLoginAsUserDetails = async (actorId) => {
	let url = config.hummBackendAppURL + "admin/get-login-as-user-details";
	return axios
		.post(url, {}, { headers: { ...sessionID(), actor: actorId } })
		.then((response) => {
			return response.data;
		})
		.catch(async (error) => {
			await userLogs(url, {}, error);
			if (error.response) {
				handlingSession(error.response.status);
			}
			return error.response;
		});
};

export const createNewAdmin = async (payload) => {
	const url = config.hummBackendAppURL + "admin/create-new-admin";
	return axios
		.post(url, payload, { headers: sessionID() })
		.then((response) => {
			return response.data;
		})
		.catch(async (error) => {
			await userLogs(url, payload, error);
			if (error.response) {
				handlingSession(error.response.status);
			}
			return error.response?.data;
		});
};

export const deleteAdmin = async (payload) => {
	const url = config.hummBackendAppURL + "admin/delete-admin";
	return axios
		.delete(url, { data: payload, headers: sessionID() })
		.then((response) => {
			return response.data;
		})
		.catch(async (error) => {
			await userLogs(url, payload, error);
			if (error.response) {
				handlingSession(error.response.status);
			}
			return error.response?.data;
		});
};
